
class PlannerHomeController {

    constructor() {
    }

    ready() {
        $('.section-home .btn-next').enableIf(true);
    }
}
